// extracted by mini-css-extract-plugin
export var actions = "_ni-5";
export var assistantBubble = "_ni-3";
export var assistantRow = "_ni-6";
export var bubble = "_ni-0";
export var humanAvatar = "_ni-4";
export var inlineToolCard = "_ni-1";
export var userBubble = "_ni-2";